import { Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { CONFIG } from "../config";

// Only allow same-origin relative paths as post-login targets.
const safeReturnTo = (returnTo) =>
  typeof returnTo === "string" &&
  returnTo.startsWith("/") &&
  !returnTo.startsWith("//")
    ? returnTo
    : "/";

const Auth0ProviderWithHistory = ({ children }) => {
  const navigate = useNavigate();

  // redirect_uri is the bare origin, so send the user back to the page they
  // originally requested (captured by withAuthenticationRequired / loginWithRedirect).
  const onRedirectCallback = (appState) => {
    navigate(safeReturnTo(appState?.returnTo), { replace: true });
  };

  return (
    <Auth0Provider
      domain={CONFIG.Auth0Domain}
      clientId={CONFIG.Auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: CONFIG.Auth0Audience,
      }}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
